<template>
  <div class="mb-5 mt-5">


    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          color="primary"
          depressed
          v-on="on"
          @click="doEdit()"
          v-if="show(actionBtnSettings.edit)"
        >
          <v-icon dark>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          depressed
          color="secondary"
          v-on="on"
          @click="doPrint()"
          v-if="show(actionBtnSettings.print)"
          :disabled="actionBtnSettings.print_disabled"
        >
          <v-icon dark>
            mdi-printer-outline
          </v-icon>
        </v-btn>
      </template>
      <span>Print</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          depressed
          color="secondary"
          v-on="on"
          @click="doSavePrint()"
          :disabled="actionBtnSettings.save_and_print_disabled"
          v-if="show(actionBtnSettings.save_and_print)"
        >
          <v-icon dark>
            mdi-printer-outline
          </v-icon>
        </v-btn>
      </template>
      <span>Save & Print</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          dark
          depressed
          color="#9ECC5E"
          v-on="on"
          @click="doRefresh()"
          v-if="show(actionBtnSettings.refresh)"
        >
          <v-icon dark>
            mdi-refresh
          </v-icon>
        </v-btn>
      </template>
      <span>Refresh</span>
    </v-tooltip>


    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          dark
          color="#FCB812"
          depressed
          v-on="on"
          @click="doSend()"
          v-if="show(actionBtnSettings.send)"
          :disabled="actionBtnSettings.send_disabled"
        >
          <v-icon dark>
            mdi-send-outline
          </v-icon>
        </v-btn>
      </template>
      <span>Send Invoice</span>
    </v-tooltip> -->

    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          class="mx-2"
          fab
          depressed
          color="grey lighten-2"
          v-on="on"
          @click="doClose()"
          :disabled="actionBtnSettings.close_disabled"
          v-if="show(actionBtnSettings.close)"
        >
          <v-icon dark>
            mdi-close
          </v-icon>
        </v-btn>
      </template>
      <span>Close</span>
    </v-tooltip>
  </div>
</template>

<script>
  export default {
    name: 'action-buttons',
    props: [ 'actionBtnSettings' ],
    data: () => ({
    }),
    computed: {
    },
    methods: {
      isDisabled: function(val){
        return val === 0 ? true : false
      },
      show: function(val){
        return val === 0 ? false : true
      },
      doEdit (){
        this.$emit('doEdit')
      },
      doSend (){
        this.$emit('doSend')
      },
      doClose (){
        this.$emit('doClose')
      },
      doRefresh (){
        this.$emit('doRefresh')
      },
      doPrint (){
        this.$emit('doPrint')
      },
      doSavePrint (){
        this.$emit('doSavePrint')
      },
      doSave (){
        this.$emit('doSave')
      },
    },
    mounted() {
    },
    components: {
    }
  }
</script>
